import { EntityAvatar } from "@/components/atoms/entity-avatar/EntityAvatar";
import { ChatConversationSchemaType } from "../../api/schemas";
import { SearchUserSchemaType } from "@/components/modules/user/api/schemas";
type Props = {
  conversation?: ChatConversationSchemaType;
  user?: SearchUserSchemaType;
  realEstateImage?: string;
  size?: "small" | "medium" | "large";
};
const SIZE_MAP = {
  small: "sm",
  medium: "lg",
  large: "xl"
} as const;
export function Avatar({
  conversation,
  user,
  realEstateImage,
  size = "medium"
}: Props) {
  if (!conversation && !user) return null;
  const listingImage = conversation?.realEstate?.picture || realEstateImage;
  return <EntityAvatar size={SIZE_MAP[size]} imageUrl={listingImage} imageAlt={conversation?.realEstate?.title || "Imóvel relacionado à conversa"} person={{
    imageUrl: conversation?.otherUser?.image || conversation?.otherUser.avatar || user?.image,
    name: conversation?.otherUser.name || user?.name || "",
    online: conversation?.otherUser.isOnline
  }} data-sentry-element="EntityAvatar" data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx" />;
}